<template>
  <fieldset class="filter-item elem" >
    <legend class="filter-item_header">
      {{ThematicCardTranslate.popin.titre_recherche_region}}
    </legend>
    <WhereAutoCompleteForm
      :locationListApi="locationListApi"
      :locationListHistory="locationListHistory"
      :resetAction="resetAutoComplete"
      @clearWhere="onClearWhere"
      @onClearLocationHistory="clearHistory('loc_hst')"
      @onFocusSearch="hideBlockFilters"
      @onLocationinput="fetchLocations($event);onLocationInput($event);"
      @onRemoveLocationItem="removeItemFromHistoryList($event, 'loc_hst')"
      @onSearch="searchLocation"
    />
  </fieldset>
</template>
<script>
import { computed, ref } from 'vue';
import WhereAutoCompleteForm from '@/components/thematicCard/WhereAutoCompleteForm.component.vue';
import { useLocations } from '@/hooks/autocomplete.hook';
import { LocalStoragePlugin } from '@/plugins';
import { ThematicCardTranslate } from '@/services/translate';

export default {
  components: {
    WhereAutoCompleteForm,
  },
  props: {
    resetActionStatus: {
      type: Boolean,
      default: false,
    },
    resetWhereStatus: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'clearWhereValue',
    'locationInput',
    'whereValue',
  ],
  setup(props, { emit }) {
    const locationListHistory = ref(
      (LocalStoragePlugin.get('loc_hst')?.split('|') || []).filter((elem) => !!elem),
    );

    const resetAutoComplete = computed(() => props.resetActionStatus || props.resetWhereStatus);

    function refreshHistoryForm(key) {
      locationListHistory.value = (LocalStoragePlugin.get(key)?.split('|') || []).filter((elem) => !!elem);
    }

    function saveItemToLocalStorage(key, value) {
      const listSearchItems = LocalStoragePlugin.get(key)?.split('|') || [];
      if (!listSearchItems.includes(value) && !!value) { listSearchItems.push(value); }
      LocalStoragePlugin.set(key, listSearchItems.join('|'));
      refreshHistoryForm(key);
    }

    function clearHistory(key = 'text_hst_d9') {
      LocalStoragePlugin.clear(key);
      refreshHistoryForm(key);
    }
    function removeItemFromHistoryList(key, index) {
      const listSearchItems = LocalStoragePlugin.get(index)?.split('|') || [];
      const indexItemToremove = listSearchItems?.findIndex(
        (val) => key === val,
      );
      if (indexItemToremove !== -1) { listSearchItems.splice(indexItemToremove, 1); }
      if (listSearchItems.length < 1) {
        clearHistory(index);
      } else {
        LocalStoragePlugin.set(index, listSearchItems.join('|'));
      }
      refreshHistoryForm(index);
    }

    const [locationListApi, fetchLocations] = useLocations();

    function searchLocation({ locationText }) {
      saveItemToLocalStorage('loc_hst', locationText);
      emit('whereValue', locationText);
    }

    function onClearWhere() {
      emit('clearWhereValue', 'vide');
    }

    function onLocationInput(event) {
      emit('locationInput', event);
    }

    function hideBlockFilters() {
      const blockFiltersElement = document.querySelector('.first-filters-collapse');
      const searchFilterBlock = document.querySelector('#search-filters');
      if (blockFiltersElement) searchFilterBlock.classList.remove('in');
      if (searchFilterBlock) blockFiltersElement.setAttribute('aria-expanded', false);
    }

    return {
      locationListApi,
      searchLocation,
      fetchLocations,
      hideBlockFilters,
      clearHistory,
      removeItemFromHistoryList,
      locationListHistory,
      onClearWhere,
      onLocationInput,
      ThematicCardTranslate,
      resetAutoComplete,
    };
  },
};
</script>
